export const FRENCH_TRANSLATIONS = {
  text: {
    web_title: 'TABLEAU DE BORD SMARTZ',
    authentication: 'Authentification',
    username: "Nom d'utilisateur",
    password: 'Mot de passe',
    sign_in: 'Se connecter',
    username_required: "Le nom d'utilisateur est requis",
    password_required: 'Le mot de passe est requis',
    invalid_credential: "Le nom d'utilisateur ou le mot de passe est incorrect",
    forgot_password: 'Mot de passe oublié ?',
    logout: 'Se déconnecter',
    languages: 'Langages',
    dashboard: 'Bord',
    products: 'Produits',
    pods: 'Gousses',
    reports: 'Rapports',
    this_website_uses_cookies: 'Ce site web utilise des cookies',
    uses_cookie_desc:
      'Nous utilisons des cookies pour personnaliser le contenu et les annonces, pour fournir des fonctionnalités des médias sociaux et pour analyser notre trafic. Nous partageons également des informations sur votre utilisation de notre site avec nos partenaires des médias sociaux, de la publicité et de l’analyse qui peuvent les combiner avec d’autres informations que vous leur avez fournies ou qu’ils ont recueillies à partir de votre utilisation de leurs services.',
    use_necessary_cookie_only: 'Tilez uniquement  les cookies nécessaires',
    allow_selection: 'Autoriser la sélection',
    allow_all_cookies: 'Autoriser tous les cookies',
    hide_details: 'Masquer les détails',
    necessary: 'Nécessaire',
    preferences: 'Préférences',
    statistics: 'Statistiques',
    marketing: 'Marketing',
    unclassified: 'Non classé',
    cookie_declaration: 'Déclaration de cookies',
    about_cookies: 'À propos des cookies',
    necessary_desc:
      'Les cookies nécessaires aident à rendre un site Web utilisable en permettant des fonctions de base comme la navigation de page et l’accès aux zones sécurisées du site Web. Le site Web ne peut pas fonctionner correctement sans ces cookies.',
    preferences_desc:
      'Les cookies de préférence permettent à un site Web de mémoriser des informations qui modifient le comportement ou l’apparence du site Web, comme votre langue préférée ou la région dans laquelle vous vous trouvez.',
    statistic_desc:
      'Les cookies statistiques aident les propriétaires de sites Web à comprendre comment les visiteurs interagissent avec les sites Web en recueillant et en signalant des informations de façon anonyme.',
    marketing_desc:
      'Les cookies marketing sont utilisés pour suivre les visiteurs sur les sites Web. L’intention est d’afficher des annonces pertinentes et engageantes pour les éditeurs et les annonceurs tiers.',
    unclassified_desc:
      'Les cookies non classifiés sont des cookies que nous sommes en train de classer, avec les fournisseurs de cookies individuels.',
    about_cookies_desc:
      'Les cookies sont de petits fichiers texte qui peuvent être utilisés par les sites Web pour rendre l’expérience d’un utilisateur plus efficace. La loi stipule que nous pouvons stocker des cookies sur votre appareil si elles sont strictement nécessaires pour le fonctionnement de ce site. Pour tous les autres types de cookies, nous avons besoin de votre permission. Ce site utilise différents types de cookies. Certains cookies sont placés par des services tiers qui apparaissent sur nos pages.',
    name: 'Nom',
    provider: 'Fournisseur',
    purpose: 'But',
    expiry: 'Expiration',
    type: 'Type',
    frequently_asked_questions: 'Questions fréquemment posées',
    information_for_use: 'Informations à utiliser',
    data_privacy: 'Confidentialité des données',
    eula: 'EULA',
    about: 'Sur',
    settings: 'Paramètres',
    my_account: 'Mon compte',
    version: 'version',
    support: 'soutien',
    close: 'Proche',
    copyright: 'Droit d’auteur (C) 2020 Simavita Pty Ltd. Tous droits réservés',
    manufacturers: 'fabricants',
    characterisation: 'caractérisation',
    address: 'adresse',
    contact: 'contact',
    action: 'action',
    view: 'vue',
    edit: 'modifier',
    add: 'ajouter',
    add_manufacturer: 'ajouter le fabricant',
    edit_manufacturer: 'modifier le fabricant',
    created: 'créé',
    details: 'détails',
    other: 'autres',
    active: 'Active',
    save: 'sauvegarder',
    product_description: 'Description du produit',
    general_product_description: 'description générale du produit',
    product_characteristics: 'Caractéristiques du produit',
    product_characterise_properties: 'propriétés caractérisées par le produit',
    description: 'Description',
    working_capacity: 'Capacité de travail',
    add_product: 'Ajouter un produit',
    edit_product: 'Modifier le produit',
    hardware: 'Matériel',
    position: 'Position',
    constant: 'Constante',
    yellow_threshold: 'Seuil jaune',
    red_threshold: 'Seuil rouge',
    firmware_version: 'Version du Firmware',
    hardware_version: 'Version Matérielle',
    thresholds: 'Seuils',
    yellow: 'Jaune',
    red: 'Rouge',
    product_characterisation: 'Caractérisation des produits',
    run: 'Courir',
    characterisation_run: 'exécution de caractérisation',
    analyse_runs: 'Analyser les courses',
    analyse_runs_desc:
      'analyser et créer des <br/> caractéristiques du produit',
    product_characterisation_run: 'Exécution de caractérisation de produit',
    tester: 'Testeur',
    pod: 'Pod',
    weight: 'Poids',
    incomplete_run: 'Exécution incomplète',
    continue: 'Continuer',
    start_new: 'commencer de nouveau',
    started: 'commencé',
    finish: 'finir',
    entries: 'Entrées',
    time: 'Heure',
    void: 'Vide',
    comment: 'Commentaire',
    add_entry: 'AJOUTER L’ENTRÉE',
    pod_data: 'Données pod',
    sensor: 'capteur',
    select: 'Sélectionnez',
    export_data: 'Données d’exportation',
    date: 'Date',
    comments_for: 'Commentaires pour',
    pad_characterization_detail_for: 'Pad Caractérisation Détail pour',
    desc: 'Desc',
    volume: 'Volume',
    median: 'Médiane',
    agg: 'Agg',
    new_agg: 'Nouveau Agg',
    sensor_value: 'valeur du capteur',
    sensor_value_agg: 'valeur du capteur agg',
    select_run_to_analyse: 'Sélectionnez Exécution à analyseur',
    product_characterisation_analysis:
      'Analyse de caractérisation des produits',
    chart_data: 'données de graphique',
    calibration: 'Étalonnage',
    capacitance_readings: 'Lectures de capacité',
    capacitance_sensor_readings: 'lectures des capteurs de capacité',
    connection_status: 'État de connexion',
    pad_connections: 'connexions pad',
    battery_levels: 'Niveaux de batterie',
    battery_level_and_status: 'Niveau et état de la batterie',
    accelerometer_readings: 'Lectures d’accéléromètre',
    ax_ay_az: 'Ax, Ay, Az et position, tombe statut',
    chart_pod_capacitance_readings: 'Graphique Pod Capacitance Lectures',
    y_axis_max: 'Axe Y max',
    auto_refresh: 'auto-actualiser',
    apply: 'Appliquer',
    latest_time: 'Dernière heure',
    countdown_to_median: 'Compte à rebours vers la médiane',
    recent_data_for: 'Données récentes pour',
    chart_pod_connection_status: 'État de la connexion du pod graphique',
    chart_pod_battery_level: 'Niveau de la batterie du pod graphique',
    chart_pod_accelerometer: 'Graphique Pod Accéléromètre',
    export_pod_data: 'Exporter des données sur les gousses',
    raw_data: 'Données brutes',
    export: 'Exportation',
    from_date: 'à partir de la date',
    to_date: 'à ce jour',
    utc_offset: 'UTC offset',
    pod_calibration: 'Étalonnage du pod',
    calibrattion_status: 'État d’étalonnage',
    capacitive: 'Capacitif',
    accelerometer: 'Accéléromètre',
    calibration_data: 'Données d’étalonnage',
    capacitive_sensor: 'Capteur capacitif',
    battery: 'Batterie',
    thermistor: 'Thermistance',
    spo2: 'SPO2',
    blood_oxygen_saturation: 'Saturation en oxygène dans le sang',
    chart_pod_spo2_readings: 'Graphique Pod SPO2 Lectures',
    live: 'Vivre',
    chart_date: 'Date graphique',
    please_select: 'S’il vous plaît sélectionner',
    product: 'produit',
    tester_required: 'testeur est nécessaire',
    product_required: 'produit est nécessaire',
    pod_required: 'pod est nécessaire',
    position_required: 'position est requise',
    weight_required: 'poids est nécessaire',
    lying_left: 'Gauche couchée',
    lying_right: 'Se trouvant à droite',
    lying_back: 'Se coucher en arrière',
    lying_front: 'Front couché',
    sit: "S' asseoir",
    stand: 'Debout',
    void_required: 'vide est nécessaire',
    comment_required: 'commentaire est nécessaire',
    please_select_a_product: 'Veuillez sélectionner un produit',
    filter_by_group_or_users: 'filtrer par groupe ou par utilisateur',
    manage: 'Gérer',
    users: 'Utilisateurs',
    roles: 'Rôles',
    user_accounts: 'COMPTES D’UTILISATEURS',
    role: 'Rôle',
    status: 'Statut',
    disabled: 'Handicapés',
    add_user_account: 'AJOUTER UN COMPTE UTILISATEUR',
    edit_user_account: 'MODIFIER LE COMPTE UTILISATEUR',
    fullname: 'Fullname',
    phone: 'Téléphone',
    email: 'E-mail',
    role_required: 'Un rôle est nécessaire',
    enter_correct_email: 'Veuillez saisir l’adresse e-mail correcte',
    email_required: 'Courrier électronique obligatoire',
    add_role: 'AJOUTER RÔLE',
    edit_role: 'Édition rôle',
    role_name: 'Liste des noms',
    role_permissions: 'Permissions rôles',
    level_1_module: 'Module niveau 1',
    level_2_module: 'Module niveau 2',
    permissions: 'Permissions',
    cancel: 'Annuler',
    filter_by_role_name: 'filtrer par nom de rôle',
    chart_time: 'Heure du graphique',
    vital_signs: 'Signes vitaux',
    heart_rate: 'Fréquence cardiaque',
    body_temperature: 'Température corporelle',
    pod_capacitance: 'capacité pod',
    pod_accel: 'sous accel',
    pod_status: 'état de la nacelle',
    name_required: 'Le nom est requis',
    address_required: 'L’adresse est requise',
    contact_required: 'Le contact est requis',
    id_required: 'L’identification est requise',
    description_required: 'La description est requise',
    working_capacity_required: 'La capacité de travail est requise',
    constant_a_required: 'La constante A est requise',
    constant_b_required: 'La constante B est requise',
    constant_c_required: 'La constante C est requise',
    constant_d_required: 'La constante D est requise',
    yellow_threshold_required: 'Seuil jaune requis',
    red_threshold_required: 'Seuil rouge est requis',
    firmware_version_required: 'Version du firmware est nécessaire',
    hardware_version_required: 'Version matérielle est requise',
    group: 'Groupe',
    reset_password: 'Réinitialiser mot de passe',
    new_password: 'Nouveau mot de passe',
    confirm_password: 'Confirmer mot de passe',
    please_enter_password: 'Veuillez entrer le mot de passe',
    please_enter_password_again: 'Veuillez entrer le mot de passe à nouveau',
    password_inconsistent: 'The mot de passe ne correspond pas',
    saved_successfully: 'Enregistré avec succès',
    s1_offset_required: 'S1_Offset est nécessaire',
    s2_offset_required: 'S2_Offset est nécessaire',
    s1_gain_required: 'S1_Gain est nécessaire',
    s2_gain_required: 'S2_Gain est nécessaire',
    bat_offset_required: 'Bat_Offset est nécessaire',
    temp_offset_required: 'Temp_Offset est nécessaire',
    acc_x_offset_required: 'Acc_XOffset est nécessaire',
    acc_x_gain_required: 'Acc_XGain est nécessaire',
    acc_y_offset_required: 'Acc_YOffset est nécessaire',
    acc_y_gain_required: 'Acc_YGain est nécessaire',
    acc_z_offset_required: 'Acc_ZOffset est nécessaire',
    acc_z_gain_required: 'Acc_ZGain est nécessaire',
    edit_roles: 'Édition rôles',
    available_roles: 'Rôles disponibles',
    assigned_roles: 'Rôles assignés',
    delete: 'Supprimer',
    you_able_to_delete_data: 'Vous êtes sur le point de supprimer',
    delete_role_confirm:
      'Veuillez garder à l’esprit que la suppression des rôles est permanente.',
    aggregate: 'Agrégat',
    magnitude: 'Ampleur',
    connection: 'Connexion',
    fall: 'Tomber',
    tag_data: 'Données de balise',
    notes: 'Notes',
    add_tag: 'Ajouter une balise',
    'Run away line': 'Ligne de fuite',
    'Non responsive line': 'Ligne non réactive',
    Divergence: 'Divergence',
    'Disconnected line': 'Ligne déconnectée',
    'Saturated readings': 'Lectures saturées',
    Unexplained: 'Inexpliquée',
    please_enter: 'S’il vous plaît entrer',
    find_data: 'Find Data',
    find_tagged_data: 'Find Tagged Data',
    find_data_with_tag: 'Find data with tag',
    find: 'Find',
    found: 'Found',
    mac_address: 'MAC Address',
    tag_timestamp: 'Tag Timestamp',
    tagged_by: 'Tagged By',
    tag: 'Tag',
    period: 'Period',
    clear_selected: 'Clear selected',
    code: 'Code',
    manufacturer_code_required: 'Le code du fabricant est requis',
    failed: 'échoué',
    product_number: 'Numéro du produit',
    manufacturer: 'Fabricant',
    product_number_required: 'Numéro du produit',
    manufacturer_required: 'Le fabricant est requis',
    urine: 'Urine',
    max_capacity: 'Capacité maximale',
    urine_details: 'Détails de l’urine',
    urine_thresholds: 'Seuils d’urine',
    max_capacity_required: 'Capacité maximale requise',
    pod_id_required: 'Identification de la capsule requise',
    choose_a_report: 'Choisissez un rapport',
    select_date_range: 'Sélection des dates',
    start_time: 'heure de démarrage',
    end_time: 'heure de fin',
    select_groups_to_collate: 'Sélectionnez le (S) groupe (S) à collationner',
    all_groups: 'Tous groupes',
    group_include: 'Groupe à inclure dans la génération de rapports',
    export_report: 'Rapport sur les exportations',
    export_csv: 'CSV d’exportation',
    //translate permission list
    Dashboard: 'Tableau de bord',
    'Pod Accel': 'Sous Accel',
    'Pod Capacitance': 'Capacité du Pod',
    Products: 'produits',
    Manufacturers: 'constructeurs',
    'Product Description': 'Description du produit',
    'Product Characteristics': 'Caractéristiques du produit',
    Run: 'cours',
    'Analyse Runs': 'Opérations d’analyse',
    Pods: 'Pods',
    'Capacitance Readings Chart': 'Tableau des relevés de Capacitance',
    'Connection Status Chart': 'Diagramme d’état de connexion',
    'Battery Levels Chart': 'Diagramme des niveaux de batterie',
    'Accelerometer Readings Chart': 'Tableau de lecture de l’accéléromètre',
    'SPO2 Chart': 'Diagramme SPO2',
    'Export Pod Data': 'Données Pod d’exportation',
    Calibration: 'étalonnage',
    Manage: 'gestion',
    Users: 'utilisateurs',
    Roles: 'rôles',
    View: 'vue',
    Add: 'ajouter',
    Edit: 'éditer',
    Delete: 'supprimer',
    Reports: 'rapports',
    'Export CSV': 'CSV d’exportation',
    Export: 'exportations',
    'Find Data': 'Trouver des données',
    'Reset Password': 'Réinitialisation du mot de passe',
    //end translate permission list
    ago: 'Il y a',
    value: 'Valeur',
    min: 'Min',
    max: 'Max',
    are_you_sure: 'Tu es sûre',
    whether_continue:
      'Vous ajouterez une entrée, veuillez confirmer s’il faut continuer'
  },
  country: 'France',
  language: 'français',
  abb_name: 'fr'
}
